import React, { type PropsWithChildren } from "react";

import { atom, useAtom } from "jotai";
import { ScopeProvider } from "jotai-scope";

import { type SalesPageMetric } from "@north-beam/nb-client-side";
import { type metrics } from "@north-beam/nb-common";

const customOnConfirmModal = atom<boolean>(false);
export const useCustomOnConfirmModal = () => useAtom(customOnConfirmModal);

const customOnConfirmSwitchMetricModal = atom<{
  type: "duplicate" | "normal";
  metricId: number | undefined;
} | null>(null);
export const useCustomOnConfirmSwitchMetricModal = () =>
  useAtom(customOnConfirmSwitchMetricModal);

const selectedMetricIdAtom = atom<number | null>(null);
export const useSelectedMetricId = () => useAtom(selectedMetricIdAtom);

const formulaAtom = atom<metrics.Token[]>([]);
export const useFormula = () => useAtom(formulaAtom);

const historyAtom = atom<metrics.Token[][]>([]);
export const useHistoryAtom = () => useAtom(historyAtom);

const currentIndexAtom = atom(0);
export const useCurrentIndex = () => useAtom(currentIndexAtom);

const metricMapAtom = atom<Record<string, SalesPageMetric>>({});
export const useMetricMap = () => useAtom(metricMapAtom);

const selectedMetricAtom = atom<metrics.CustomMetric | undefined>(undefined);
const selectedMetricIsDirtyAtom = atom<boolean>(false);

export const useSelectedMetric = () => useAtom(selectedMetricAtom);
export const useSelectedIsDirtyMetric = () =>
  useAtom(selectedMetricIsDirtyAtom);

const hasSubmittedMetricAtom = atom<boolean>(false);
export const useHasSubmittedMetric = () => useAtom(hasSubmittedMetricAtom);

export const CustomMetricsAtomsProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  return (
    <ScopeProvider
      atoms={[
        customOnConfirmSwitchMetricModal,
        selectedMetricIdAtom,
        formulaAtom,
        historyAtom,
        currentIndexAtom,
        metricMapAtom,
        selectedMetricAtom,

        selectedMetricIsDirtyAtom,
        customOnConfirmModal,
      ]}
    >
      {children}
    </ScopeProvider>
  );
};
